/**
 * Snack Bar transitions.
 */
enum Transitions {
  SLIDE = "Slide",
  GROW = "Grow",
}

export default Transitions;
